module.exports = __webpack_public_path__ + "img/28.0d01f7ca.jpg";